import React, { useState } from 'react';
import '../css/checkbox.css';

export interface CheckboxProps {
  id?: string;
  name?: string;
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  label?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  id,
  name,
  checked,
  defaultChecked = false,
  onChange,
  disabled = false,
  className = '',
  label,
}) => {
  const [isChecked, setIsChecked] = useState(defaultChecked);

  // Use controlled or uncontrolled state
  const checkboxChecked = checked ?? isChecked;

  const handleChange = () => {
    if (disabled) return;

    const newChecked = !checkboxChecked;

    if (checked === undefined) {
      setIsChecked(newChecked);
    }

    if (onChange) {
      onChange(newChecked);
    }
  };

  return (
    <label
      className={`scl--web-component-checkbox-container ${className} ${disabled ? 'disabled' : ''}`}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={checkboxChecked}
        onChange={handleChange}
        disabled={disabled}
        className="scl--web-component-checkbox-input"
        autoComplete='off'
      />

      <div
        className={`scl--web-component-checkbox-box ${checkboxChecked ? 'checked' : ''} ${disabled ? 'disabled' : ''}`}
      >
        {checkboxChecked && (
          <svg
            className="scl--web-component-checkbox-check-icon"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M2 7L5.5 10.5L12 4"
              stroke="#FFFFFF"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>

      {label && (
        <span className="scl--web-component-checkbox-label">
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;